const PAIRS: ReadonlyArray<readonly [number, string]> = [
  [10, 'X'],
  [9, 'IX'],
  [5, 'V'],
  [4, 'IV'],
  [1, 'I'],
]

export function toRoman(value: number): string {
  if (value <= 0) return '0'
  let rest = value
  let out = ''
  for (const [n, s] of PAIRS) {
    while (rest >= n) {
      out += s
      rest -= n
    }
  }
  return out
}
